import { FieldErrors, FieldValues } from 'react-hook-form';
import { toast } from 'react-toastify';

import { getTranslation } from './get-translation.util';

export const handleFormInvalidField = <T extends FieldValues>(
  errors: FieldErrors<T>,
  fieldLabel?: string,
): void => {
  if (Object.keys(errors).length === 0) return;

  const message = fieldLabel
    ? getTranslation('PLEASE_FIX_THE_FIELD', { field: fieldLabel })
    : getTranslation('PLEASE_FIX_THE_HIGHLIGHTED_FIELDS');

  toast(message, {
    position: 'bottom-center',
    type: 'error',
    theme: 'light',
  });
};

// Kept at a single argument so it can stay a bare `handleSubmit(onValid, handleFormInvalid)`
// callback — React Hook Form passes the submit event as the second argument there.
export const handleFormInvalid = <T extends FieldValues>(errors: FieldErrors<T>): void =>
  handleFormInvalidField(errors);
